import React from "react";
import PropTypes from "prop-types";
import { useHistory } from "react-router-dom";
import { PageTitle } from "../../components";
import ListSection from "./ListSection";
import {
  TabList,
  Tab,
  Divider,
  Anchor,
} from "discover.medical.react-component-library";
import { StyledPageDescription, StyledTabsWrapper } from "./_.styled";
import { useTelemetry } from "./hooks/useTelemetry";

const ChemoRegimensList = ({
  browsePath,
  title,
  description,
  descriptionLink,
  tabs,
  diseases,
  agents,
  noDataText,
  sharedTelemetryData,
}) => {
  const history = useHistory();
  const activeTabIndex = tabs.findIndex((tab) => tab.path.includes(browsePath));
  const { onTabClick, onListItemClick } = useTelemetry({
    sharedTelemetryData,
    activeTab: tabs[activeTabIndex],
    history,
  });
  const listProps = { onItemClick: onListItemClick, noDataText };

  return (
    <>
      <PageTitle>{title}</PageTitle>
      <StyledPageDescription
        marginBottom="md"
        adornment={
          <Anchor
            fontSize="sm"
            glyphSize="xs"
            href={descriptionLink.href}
            target={descriptionLink.target}
            glyph={descriptionLink.glyph}
            floatLeft={false}
          >
            {descriptionLink.label}
          </Anchor>
        }
      >
        {description + " "}
      </StyledPageDescription>
      <StyledTabsWrapper>
        <TabList activeTab={activeTabIndex} indicatorColor="primary">
          {tabs.map((tab) => (
            <Tab
              key={tab.id}
              id={tab.id}
              label={tab.title}
              onClick={() => onTabClick(tab)}
            />
          ))}
        </TabList>
        <Divider noMargin />
      </StyledTabsWrapper>
      {!!diseases && <ListSection {...listProps} diseases={diseases} />}
      {!!agents && <ListSection {...listProps} agents={agents} />}
    </>
  );
};

ChemoRegimensList.propTypes = {
  browsePath: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  descriptionLink: PropTypes.shape({
    glyph: PropTypes.string,
    href: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    target: PropTypes.string,
  }).isRequired,
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
      path: PropTypes.string.isRequired,
    })
  ),
  diseases: PropTypes.arrayOf(PropTypes.object),
  agents: PropTypes.arrayOf(PropTypes.object),
  noDataText: PropTypes.string.isRequired,
  sharedTelemetryData: PropTypes.shape({
    browseType: PropTypes.string.isRequired,
  }).isRequired,
};

export default ChemoRegimensList;
